(function(){
  function pick(s){
    var f=s.closest('[data-swatches]');
    if(f){f.querySelectorAll('[data-sw]').forEach(function(b){b.setAttribute('aria-pressed',b===s?'true':'false');});}
    var id=document.getElementById('vid');if(id)id.value=s.getAttribute('data-sw');
    var d=s.dataset;
    document.querySelectorAll('[data-vprice]').forEach(function(p){p.textContent=d.price;});
    var vn=document.getElementById('vname');if(vn)vn.textContent=d.name;
    document.querySelectorAll('[data-vname]').forEach(function(p){p.textContent=d.name;});
    var ok=d.avail==='1';
    document.querySelectorAll('[data-buy]').forEach(function(b){b.disabled=!ok;b.textContent=ok?'Add to bag':'Sold';b.style.opacity=ok?'':'.45';b.style.cursor=ok?'':'not-allowed';});
    var m=document.getElementById('pmain');
    if(m&&d.src){m.src=d.src;if(d.srcset){m.srcset=d.srcset;}else{m.removeAttribute('srcset');}if(d.alt)m.alt=d.alt;
      if(window.innerWidth>1060){var r=m.getBoundingClientRect();if(r.bottom<120||r.top>window.innerHeight){m.scrollIntoView({behavior:'smooth',block:'start'});}}}
    try{var u=new URL(location.href);u.searchParams.set('variant',s.getAttribute('data-sw'));history.replaceState(null,'',u.toString());}catch(err){}
  }
  document.addEventListener('click',function(e){
    var s=e.target.closest('[data-sw]');
    if(s){e.preventDefault();pick(s);return;}
    var b=e.target.closest('[data-back]');
    if(b){e.preventDefault();if(history.length>1&&document.referrer&&document.referrer.indexOf(location.host)>-1){history.back();}else{location.href='/';}return;}
    var m=e.target.closest('#burger');
    if(m){var n=document.getElementById('mnav');var o=!n.classList.contains('open');n.classList.toggle('open',o);m.setAttribute('aria-expanded',o);return;}
    var x=e.target.closest('#annX');
    if(x){document.getElementById('ann').hidden=true;try{sessionStorage.setItem('wej-ann','0');}catch(err){}return;}
    var t=e.target.closest('[data-thumb]');
    if(t){e.preventDefault();var main=document.getElementById('pmain');if(main){main.src=t.getAttribute('data-thumb');main.removeAttribute('srcset');}return;}
  });
  try{if(sessionStorage.getItem('wej-ann')==='0'){var a=document.getElementById('ann');if(a)a.hidden=true;}}catch(err){}
  ['f-sort'].forEach(function(id){var el=document.getElementById(id);if(!el)return;el.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',el.value);u.searchParams.delete('page');location.href=u.toString();});});
  var sb=document.getElementById('sb');
  if(sb){window.addEventListener('scroll',function(){var r=document.querySelector('.info .row');sb.classList.toggle('on',!!r&&r.getBoundingClientRect().bottom<0);},{passive:true});}
})();
